var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  focusable: "false"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "share")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 16.12a2.91 2.91 0 00-2 .77l-7.09-4.15A3.27 3.27 0 009 12a3.27 3.27 0 00-.09-.7L16 7.23A3 3 0 1015 5a3.27 3.27 0 00.09.7L8 9.85a3 3 0 100 4.38l7.12 4.16a2.82 2.82 0 00-.08.65A2.92 2.92 0 1018 16.12z"
})));
export default SvgShare;